import InfoTooltip from 'components/InfoTooltip';
import { ComponentProps, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * The caption above a drawer filter, with its optional info tooltip. `children` sits at the far end of
 * the row — the "exclude selections" checkbox, for the filters that offer one.
 */
export function FilterLabel({
    label,
    tooltip,
    tooltipValues,
    children,
}: {
    label: string;
    tooltip?: string;
    tooltipValues?: ComponentProps<typeof FormattedMessage>['values'];
    children?: ReactNode;
}) {
    return (
        <div className="flex items-center gap-1">
            <span className="text-body1 text-fg-secondary">{label}</span>
            <InfoTooltip text={tooltip} values={tooltipValues} label={label} />
            {children}
        </div>
    );
}
